import { useMemo } from "react";
import { useLocale } from "react-aria-components";
import { formatCurrency } from "./formatCurrency.ts";
import { formatNumber } from "./formatNumber.ts";
import { formatPercentage, formatToPercentage } from "./formatPercentage.ts";

export function useNumberFormatters() {
    const { locale } = useLocale();

    return useMemo(
        () => ({
            formatNumber: (value: number, options?: Intl.NumberFormatOptions) => formatNumber(value, options, locale),
            formatPercentage: (value: number, decimals?: number) => formatPercentage(value, decimals, locale),
            formatToPercentage: (value: number, total: number, decimals?: number) =>
                formatToPercentage(value, total, decimals, locale),
            formatCurrency: (amount: number, currency: string) => formatCurrency(amount, currency, locale)
        }),
        [locale]
    );
}

export type NumberFormatters = ReturnType<typeof useNumberFormatters>;
